module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_05.34f2406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_05.png
// module id = bGkm
// module chunks = 10